<template>
    <b-modal v-model="modal.show"
             centered
             :title="action + ' producto'"
    >
        <form @submit.prevent="validateForm()"
              data-vv-scope="product"
        >
            <b-row>
                <b-col>
                    <b-form-group>
                        <label for="name">Nombre</label>
                        <el-input id="name"
                                  name="name"
                                  size="small"
                                  type="text"
                                  v-model="product.name"
                                  data-vv-as=" "
                                  v-validate="'required|min:1|max:255'"
                                  @input="change = true"
                                  class="text-uppercase"
                        />
                        <span class="text-danger small"
                              v-text="errors.first('product.name')"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="11">
                    <b-form-group>
                        <label for="prod_manufacturer_id">Fabricante</label>
                        <el-select id="prod_manufacturer_id"
                                   name="prod_manufacturer_id"
                                   v-model="product.prod_manufacturer_id"
                                   size="small"
                                   filterable
                                   remote
                                   :remote-method="getManufacturers"
                                   clearable
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   @change="change = true"
                        >
                            <el-option v-for="manufacturer in manufacturers"
                                       :key="manufacturer.id"
                                       :label="manufacturer.nombre"
                                       :value="manufacturer.id"
                            />
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="1"
                       class="pl-0"
                >
                    <label class="w-100">&nbsp;</label>
                    <b-button @click="openModalManufacturer"
                              variant="primary"
                              class="mr-1"
                              size="sm"
                    >
                        <i class="fa fa-plus"/>
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group>
                        <label for="sys_list_state_id">Estado físico</label>
                        <el-select id="sys_list_state_id"
                                   name="sys_list_state_id"
                                   v-model="product.sys_list_state_id"
                                   size="small"
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   @change="change = true"
                        >
                            <el-option v-for="state in states"
                                       :key="state.id"
                                       :label="state.text"
                                       :value="state.id"
                            />
                        </el-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </form>

        <template #modal-footer>
            <div class="w-100">
                <b-row>
                    <b-col cols="12"
                           class="text-right"
                    >
                        <b-button @click="closeModal"
                                  variant="secondary"
                                  class="mx-1"
                                  size="sm"
                        >
                            <i class="fa fa-close"></i> Cancelar
                        </b-button>
                        <b-button @click="validateForm"
                                  variant="primary"
                                  class="mr-1"
                                  size="sm"
                                  :disabled="!change"
                        >
                            <span>
                                <span v-if="action === 'Crear'">
                                    <i class="fa fa-save"/> Guardar y continuar
                                </span>
                                <span v-else>
                                    <i class="fa fa-save"

                                    /> Guardar
                                </span>
                            </span>
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </template>

    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal',
    data() {
        return {
            change: false
        };
    },
    computed: {
        ...mapState('productsCalculator', [
            'modal',
            'product',
            'action',
            'manufacturers',
            'states'
        ])
    },
    methods: {
        ...mapActions('productsCalculator', [
            'getManufacturers',
            'createProduct',
            'updateProduct'
        ]),
        ...mapMutations('productsCalculator', [
            'setModalShow',
            'resetManufacturer',
            'setShowToModalManufacturer',
            'resetProduct'
        ]),
        closeModal() {
            if (this.action === 'Crear') {
                this.resetProduct();
            }

            this.setModalShow(false);
            this.change = false;
        },
        openModalManufacturer() {
            this.resetManufacturer();
            this.setModalShow(false);
            this.setShowToModalManufacturer(true);
            this.change = true;
        },
        validateForm() {
            this.$validator.validateAll('product')
                .then(async (result) => {
                    if (result) {
                        if (this.action === 'Crear') {
                            await this.createProduct()
                                .then((product) => {
                                    this.$router.push(`/calculadora/producto/${product.id}/${product.slq_company_id}`);
                                });
                        } else if (this.action === 'Editar') {
                            if (this.change) {
                                await this.updateProduct();
                            }
                        }

                        this.change = false;
                    }
                });
        }
    }
};
</script>

<style>
.text-uppercase input {
    text-transform: uppercase;
}
</style>
